import React, { Component } from 'react'
import { 
  Row, 
  Col,
  Card,
  CardBody,
  Button
} from 'reactstrap'
import ReactTable from 'react-table'

import PageTitle from 'components/Title'
import SearchForm from './SearchForm'
import CreateTreatment from './Create'
import UpdateTreatment from './Update'
import LoadingOverlay from 'components/Indicator/LoadingOverlay'

import WithTreatments from './actions' 

class Treatments extends Component {

  componentDidMount = () => this.props.getTreatments()

  render = () => {
    return (
      <>
        <PageTitle
          heading="Treatments"
          subheading="Listings of all the treatments presence in the system."
          icon="pe-7s-note2 icon-gradient bg-happy-itmeo"
          buttons={[
            {  
              color: 'primary',
              onClick: () => this.props.onChangeTreatmentsHOC( 'showCreateTreatment', true ),
              content: 'Add treatment'
            }
          ]} />
        <div>
          <Row>
            <Col md={ 12 }>
              <SearchForm { ...this.props } />
              <Card className="main-card mb-3">
                <CardBody>
                  <ReactTable
                    data={ this.props.treatments }
                    columns={[
                      {
                        Header: 'Name',
                        accessor: 'name'
                      },
                      {
                        Header: 'Price',
                        accessor: 'price'
                      },
                      {
                        Header: 'Actions',
                        maxWidth: 120,
                        Cell: ( row ) => (
                          <>
                            <Button
                              className="mb-2 mr-2 btn-icon btn-icon-only"
                              color="primary"
                              onClick={() => {
                                this.props.getSelectedTreatment( row.original.id )
                              }}>
                              <i className="pe-7s-pen btn-icon-wrapper"> </i>
                            </Button>
                            <Button
                              className="mb-2 mr-2 btn-icon btn-icon-only"
                              color="danger"
                              onClick={() => {
                                Promise.all([
                                  this.props.onChangeTreatmentsHOC( 'toRemoveID', row.original.id )
                                ]).then(() => {
                                  this.props.onChangeTreatmentsHOC( 'showPromptModal', true )
                                })
                              }}>
                              <i className="pe-7s-trash btn-icon-wrapper"> </i>
                            </Button>
                          </>
                        )
                      }
                    ]}
                    defaultPageSize={ 10 } />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
        <CreateTreatment { ...this.props } />
        <UpdateTreatment { ...this.props } />
        { this.props.onLoadTreatments && <LoadingOverlay /> }
      </>
    )
  }
}

export default WithTreatments( Treatments )